import cxs from 'cxs';
import cx from 'classnames';

import { INPUT } from '../../../common/styles/Input';
import { COLOURS, FONT_SIZES, FONT_WEIGHTS } from '../../../common/styles/vars';

export const INPUT_STYLES = (
{ valid, disabled }) =>
INPUT({
  disabled,
  valid,
  hasSuffix: !valid
});

export const SELECTED_TAG_INPUT_CONTAINER = cxs({
  borderColor: `${COLOURS.cyan.turquoise} !important`
});

export const TAG_INPUT_CONTAINER = (
{ valid, disabled }) =>
cx(INPUT_STYLES({ valid, disabled }), cxs({
  padding: '0 20px',
  display: 'flex',
  alignItems: 'center',
  overflowY: 'auto',
  flexFlow: 'row wrap',
  position: 'relative',
  textOverflow: 'ellipsis',
  maxHeight: '180px',
  background: COLOURS.mono.white,
  height: 'fit-content',
  border: '1px solid #d4d9e2',
  borderRadius: '4px !important',

  ' > div': {
    display: 'inline-flex',
    overflow: 'hidden'
  },

  ':hover:not(:focus-within)': {
    borderColor: COLOURS.grey.regent,

    ...(disabled ? {
      borderColor: COLOURS.grey.mischka.russian
    } : {})
  },

  ':focus': {
    borderColor: COLOURS.grey.darkDenim
  },

  ':focus-within': {
    borderColor: COLOURS.grey.darkDenim
  }
}));

export const DISABLED_TAG_INPUT_CONTAINER = cx(INPUT_STYLES, cxs({
  background: COLOURS.grey.athens.zeus
}));

export const TAG = cxs({
  margin: '6px 5px 6px 5px'
});

export const TAG_INPUT = cxs({
  background: 'transparent',
  border: 0,
  outline: 'none',
  color: 'inherit',
  caretColor: 'inherit',
  fontSize: 'inherit',
  display: 'inline-flex',
  flex: 'auto',
  padding: '7px',
  lineHeight: '1.25px'
});

export const TAG_INPUT_ERROR = cxs({
  position: 'absolute',
  right: '20px',
  color: COLOURS.red.thunderBird,
  fontSize: FONT_SIZES.small,
  fontWeight: FONT_WEIGHTS.medium
});

export const TAG_INPUT_MAX = cxs({
  position: 'absolute',
  right: '20px',
  opacity: 0.35
});